'use client'
import * as React from 'react'
import { ApolloContext } from './ApolloContext'
import { Toaster } from './Toast/Toaster'
import Modal from './ModalContext/Modal'

type ProvidersProps = {
  children: React.ReactNode
}

export default function Providers(props: ProvidersProps) {
  return (
    <>
      <ApolloContext>
        {props.children}
        <Toaster />
        <Modal />
      </ApolloContext>
    </>
  )
}
